import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { useAppTheme } from "../../theme/useAppTheme";

const DashboardNotificationDialog = ({ open, onClose, notification }) => {
  const themeColors = useAppTheme();
  if (!notification) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 6,
          overflow: "visible",
          background: "transparent",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: -25,
          left: "50%",
          transform: "translateX(-50%)",
          background: themeColors.primary,
          backdropFilter: "blur(8px)",
          border: `1px solid ${themeColors.scaffold}`,
          color: themeColors.text,
          zIndex: 20,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent
        sx={{
          p: 0,
          borderRadius: 6,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            background: themeColors.primary,
            padding: "45px 20px 30px",
            textAlign: "center",
            color: themeColors.text,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              fontSize: 24,
            }}
          >
            {notification.title}
          </Typography>
        </Box>
        <Box
          sx={{
            background: themeColors.primary,
            padding: "35px 20px",
            textAlign: "center",
            color: themeColors.text,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: 20,
              fontWeight: 500,
            }}
          >
            {notification.body}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DashboardNotificationDialog;
